import { createContext, useState } from "react";
import sun from "../assets/images/header/Sun.png";
import moon from "../assets/images/header/Moon.png";
import "../i18n";

export const LangContext = createContext({
  image: "",
  textMode: "",
  isOpen: false,
  setTextMode: () => {},
  setImage: () => {},
  loadLang: () => {},
  lightMode: () => {},
  darkMode: () => {},
  setIsOpen: () => {},
});

export const LangContextProvider = (props) => {
  const [image, setImage] = useState(moon);
  const [textMode, setTextMode] = useState("mode1");
  const [isOpen, setIsOpen] = useState(false);

  const loadLang = () => {
    const allP = document.getElementsByTagName("p");
    const allDiv = document.getElementsByTagName("div");
    const langStorage = localStorage.getItem("language");

    if (langStorage === "fa" || langStorage === "ar") {
      for (let i = 0; i < allP.length; i++) {
       allP[i].classList.remove("text-start");
        allP[i].classList.add("text-end");
      
      }
    
      document.dir = "rtl";
    } else {
      for (let i = 0; i < allP.length; i++) {
          allP[i].classList.remove("text-end");
        allP[i].classList.add("text-start");
      
      }
   
      document.dir = "ltr";
    }
  };

  const darkMode = () => {
    document.body.classList.add("dark");
    setImage(sun);
    setTextMode("mode2");
  };

  const lightMode = () => {
    document.body.classList.remove("dark");
    setImage(moon);
    setTextMode("mode1");
  };

  const contextValue = {
    image,
    setImage,
    textMode,
    setTextMode,
    loadLang,
    lightMode,
    darkMode,
    isOpen,
    setIsOpen,
  };

  return (
    <LangContext.Provider value={contextValue}>
      {props.children}
    </LangContext.Provider>
  );
};
